module.exports = __webpack_public_path__ + "static/media/photo2-1.678cd372.jpg";